import languageJP from 'datatables.net-plugins/i18n/ja.json'

// select2オートフォーカスしない不具合を修正
$(document).on('select2:open', () => {
  document.querySelector('.select2-search__field').focus();
});

/**
 * 存在しているモーダルの取得
 * @param {*} id
 * @returns Modal
 */
export const getModal = (id) => {
  const modalEl = document.getElementById(id)
  const modal = bootstrap.Modal.getInstance(modalEl)
  return modal
}
/**
 * モーダルの作成
 * @param {*} id
 * @param {*} dispose
 * @returns Modal
 */
export const createModal = (id, dispose = true) => {
  const modalEl = document.getElementById(id)
  const modal = new bootstrap.Modal(modalEl)
  if(dispose == true){
    modalEl.addEventListener('hidden.bs.modal', function (e) {
      $(this).remove();
    })
  }
  return modal
}
/**
 * 確認メッセージモーダルの表示
 * @param {*} message
 */
export const  confirmMessage = (message, title = "入力エラー") =>{
  const modal = getModal('confirm-modal')
  $('#confirm-modal .modal-title').text(title)
  $('#confirm-modal .modal-body').html(message)
  modal.show()
}
/**
 * 半角にの変換
 * @param {*} input
 * @returns
 */
export const toHalfWidth = (input) => {
  return input.replace(/[！-～]/g,
      function(input){
        return String.fromCharCode(input.charCodeAt(0)-0xFEE0);
      }
    );
}
/**
 * ファイルダウンロード
 * @param {*} url
 * @param {*} data
 */
export const exportFile = (url, data = undefined) => {
  $.ajax({
    url: url,
    method: 'get',
    data: data
  })
  .done(data=>{
    window.open(`${data}`,'_blank');
  })
  .fail(resp=>{
    showError(resp, false)
  })
}
/**
 * エラーメッセージの表示
 * @param {*} resp レスポンス
 * @param {*} isModal モーダル表示中の場合、モーダル上でメッセージが表示される
 */
export const showError = (resp, isModal = true) => {
  // エラーメッセージをクリアする
  $('.errors').html('');
  $('.system-error').html('')

  if (isModal === true) {
    if(resp.responseJSON.errors){
      $('.errors').html(resp.responseJSON.errors)
    }else if(resp.responseJSON.system_error){
      $('.errors').html(resp.responseJSON.system_error)
    }
  } else {
    if(resp.responseJSON.errors){
      $('.errors').html(resp.responseJSON.errors)
    }else if(resp.responseJSON.system_error){
      $('.system-error').html(resp.responseJSON.system_error)
    }
  }
  $('html, body').animate({scrollTop: 0}, 150);
}

/**
 * datatablesの共通設定
 */
export const datatablesCommonOptions = {
  ordering: false,
  info: false,
  lengthChange: false,
  autoWidth: false,
  searching: false,
  bProcessing: true,
  bServerSide: true,
  paging: false,
  processing: false,
  language: languageJP,
  responsive: false,
}

/**
 * redirectTo URLにページ遷移する
 *
 * @param {string} href_url 遷移先URL
 * @param {array} param GETパラメータ
 */
export const redirectTo = (href_url, param) => {
  console.log(href_url);
  console.log(param);

  var url  = href_url;
  // 個別GETパラメータ設定(画面遷移時に必要なパラメータをURLに追加する)
  var count = 0;
  for ( var key in param ) {
    if ( param.hasOwnProperty(key) ) {
      var val = param[key];
      if (count == 0) {
        url = url + '?' + key + '=' + val;
      } else {
        url = url + '&' + key + '=' + val;
      }
      count++;
    }
  }
  // ページ遷移
  return window.location.href = url;
}

/**
 * serializeしたstringを配列データに変換
 *
 * @param {array} inputArr serializeしたstring
 */
export const prepareSubmitData = (inputArr) => {
  // データを格納するため配列を初期化する
  const data = [];
  const keyArr = [];

  // キーリストを検索
  for (let i = 0; i < inputArr.length; i++) {
    const element = inputArr[i];
    const existingKey = keyArr.find(item => item === element.name);
    if (existingKey) {
      break;
    } else {
      keyArr.push(element.name);
    }
  }

  let item = {};
  // 各キーと値のペアに対して繰り返す
  inputArr.forEach(element => {
    if (element.name == keyArr[0]) {
      item = {};
    }
    item[element.name] = element.value;
    if (element.name == keyArr[keyArr.length - 1]) {
      data.push(item);
    }
  });

  return data;
};

/**
 * serializeしたstringを配列データに変換
 *
 * @param {string} dataString serializeしたstring
 */
export const stringToArray2 = (dataString) => {
  // 文字列をキーと値のペアに分割する
  const keyValuePairs = dataString.split('&');

  // データを格納するためのJSON配列を初期化する
  const jsonData = [];
  const keyArr = [];

  let allKeyFoundFlg = false;
  // キーリストを検索
  for (let i = 0; i < keyValuePairs.length; i++) {
    const element = keyValuePairs[i];
    const [key, value] = element.split('=');
    const existingKey = keyArr.find(item => item === key);
    if (existingKey) {
      break;
    } else {
      keyArr.push(key);
    }
  }

  let item = {};
  // 各キーと値のペアに対して繰り返す
  keyValuePairs.forEach(pair => {
    const [key, value] = pair.split('=');

    if (key == keyArr[0]) {
      item = {};
    }

    item[key] = value;

    if (key == keyArr[keyArr.length - 1]) {
      jsonData.push(item);
    }
  });

  return jsonData;
};

/**
 * 現在日付を取得
 */
export const getCurrentDate = () => {
  var now = new Date();
  var month = (now.getMonth() + 1);
  var day = now.getDate();
  if (month < 10)
    month = "0" + month;
  if (day < 10)
    day = "0" + day;

  return now.getFullYear() + '-' + month + '-' + day
}

/**
 * 出力
 * @param {*} url
 * @param {*} data
 * @param {*} file_name
 */
export const blobExportExcel = (url, data, file_name) => {
  window.axios({
    url: url,
    method: 'post',
    data: data,
    responseType: 'blob'
  })
  .then(response => {
    if(response){
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', file_name); // ファイル名を設定
      document.body.appendChild(link);
      link.click();
    }else{
      $('.system-error').html(`
      <div class="system-error alert alert-danger alert-dismissible fade show">
      サーバーでエラーが発生しました。<br>管理者にご連絡ください。
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
      `)
    }
  })
  .catch(error => {
    console.error(error);
  })
}

/**
 *
 * @returns
 */
export const currentDateTime = () =>{
  const currentdate = new Date();
  return `${currentdate.getFullYear()}${(currentdate.getMonth()+1)}${currentdate.getDate()}${currentdate.getHours()}${currentdate.getMinutes()}${currentdate.getSeconds()}`;
}

/**
 * 数字チェック
 *
 * @param {*} data
 * @returns boolean
 */
export const isNumber = (data) =>{
  const regexOnlyNumber = /^\d+$/g;
  if (data.match(regexOnlyNumber)) return true;
  return false;
}

/**
 * 更新メッセージの表示
 */
export const showUpdateMessage = (msg = '') => {
    // Toastのインスタンス作成
    const toastElem = document.getElementById("liveToast");
    const toastBS = bootstrap.Toast.getOrCreateInstance(toastElem);

    // Toastのメッセージ設定
    const toastMessageElem = document.getElementById("toast-message");
    if(msg === '') {
      toastMessageElem.innerHTML = '登録しました。';
    } else {
      toastMessageElem.innerHTML = msg;
    }

    // Toast表示
    toastBS.show();
}

/**
 * モーダルを閉じる際の確認メッセージ表示
 * @param {*} closeDOM
 * @param {*} modalDOM
 */
export const setFormEventHandler = (closeDOM, modalDOM = '') => {
  var isChange = false;
  $("form").on('change', (e) => {
    var target = $( e.target )
    console.log(target)
    if ( target.attr('class').includes('check-need-form')) {
      isChange = true;
    }
  });

  $(closeDOM).on("click", (e) => {
    var modal = null;
    if (modalDOM !== '') {
      modal = getModal(modalDOM);
    }

    if (isChange) {
      var cnf = confirm("変更された内容は破棄されます。よろしいですか？")
      if (!cnf) {
        e.preventDefault();
        e.stopImmediatePropagation();
      } else {
        if (modal) modal.hide();
      }
    } else {
      if (modal) modal.hide();
    }
  })
}

/**
 * 画面遷移の際の確認メッセージ表示
 * @param {} str
 * @returns
 */
export const setConfirmMsgEventHandler = (cancelDOM, redirectURL, isAdd = false) => {
    var isChange = false;

    $('body').off('change click', '.check-need-form');
    $(cancelDOM).off('click');

    if (isAdd) isChange = true;
    // 変更フラグを立てる（入力欄）
    $('body').on('change', '.check-need-form', function(){
      isChange = true;
    });
    // 変更フラグを立てる（ボタン）
    $('body').on('click', '.check-need-form', function(){
      isChange = true;
    });

    $(cancelDOM).on("click", () => {
      if(isChange) {
        var cnf = confirm("変更された内容は破棄されます。よろしいですか？");
        if (!cnf) {
          return;
        }
      }
      redirectTo(redirectURL);
    })
  }
/**
 * 数値のゼロ埋めを無視する処理
 */
export const suppressZero = str => {
  // 先頭の0を削除
  return str.replace(/^0+/, '');
};

/**
 * クッキーの全削除
 */
export const deleteAllCookies = () =>{
  const cookies = document.cookie.split(';')
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i]
    const eqPos = cookie.indexOf('=')
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
    document.cookie = name + '=;max-age=0'
  }
};
